<template>
  <div class="team">
    <Header 
      title="Criar um time"
      subtitle="Você poderá personalizar melhor no próximo passo #fikdik"
    ></Header>
    <div class="container">

      <div class="row justify-content-center">
        <div class="col-8">
          <form @submit.stop.prevent="handleSubmit">
            <b-form-group description="" label="Nome do Time">
              <b-form-input v-model="team.name"
                type="text"
                maxlength="50"
                placeholder="" required>
              </b-form-input>
            </b-form-group>
            <b-form-group description="" label="TAG para dentro do jogo">
              <b-form-input v-model="team.tag"
                type="text"
                maxlength="20"
                placeholder="" required>
              </b-form-input>
            </b-form-group>
            <b-form-group description="" label="Senha para novos jogadores">
              <b-form-input v-model="team.secret_code"
                type="text"
                maxlength="20"
                placeholder="" required>
              </b-form-input>
            </b-form-group>
            <b-form-group description="" label="Sobre o time">
              <b-form-textarea v-model="team.about"
                maxlength="250"
                rows="3"
                placeholder="" required>
              </b-form-textarea>
            </b-form-group>
            <b-form-group description="" label="Email do Responsável">
              <b-form-input v-model="team.email"
                type="email"
                maxlength="150"
                placeholder="" required>
              </b-form-input>
            </b-form-group>

            <b-button type="submit" size="lg" variant="primary">Cadastrar Time</b-button>
          </form>
        </div>
      </div>
        
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'

export default {
  name: 'TeamCreate',
  metaInfo: {
    title: 'Criar um time'
  },
  data () {
    return {
      team: {}
    }
  },
  methods: {
    handleSubmit () {
      this.$http.post(`teams.json`, { team: this.team })
          .then(response => {
            this.$notify({
              group: 'all',
              title: 'Time criado com sucesso!',
            });
            this.$router.push({ name: 'TeamSingle', params: { id: response.data.id }})
          })
          .catch(response => {
            // alert(JSON.stringify(response.data))
          })
    },
  },
  mounted () {
  },
  components: {
    Header
  }
}
</script>

<style lang="sass" scoped>
.user-stats
  background: rgba(0, 0, 0, .1)
  padding: 20px
  text-align: center
  margin: 20px 0
.stats-box
  display: flex
  justify-content: space-between
  background: rgba(0, 0, 0, .12)
  padding: 10px 0
  .stat-box
    width: 30%
    p
      margin: 0
    p.heading
      text-transform: uppercase
      text-align: center
      font-size: 13px
    p.title
      text-align: center
      font-weight: bold
      font-size: 20px
// .members-list
//   display: flex
//   flex-wrap: wrap
//   justify-content: space-between
</style>
